// import pages
import FooterB from "../layout/FooterB";
import VideoView from "./VideoView";

// import style
import "../../style/pages/videos/videos.scss";

const Videos = () => {
  return (
    <div className="videos-section">
      <div className="container main-section">
        <div className="responsive-main-section">
          <div className="title-section background-purple">
            <a href="/videos" className="title-link">
              <div className="title font-amaticsc-bold">Videos</div>
              <div className="sub-title font-zenkurenaido">動画</div>
            </a>
          </div>
          <div className="content-section">
            <div className="en-content font-outfit-bold">
              Browse below to see our collection of videos about various
              language-related topics.
              <br />
              <br />
              Have a question for Ben-sensei about English, Japanese, or
              language learning? Feel free to ask it{" "}
              <a href="/contact" className="en-question-link">
                here!
              </a>
            </div>
            <div className="jp-content font-kleeone">
              以下の動画コレクションでは、さまざまな言語に関するトピックを取り上げています。
              <br />
              <br />
              英語や日本語、語学学習についてベン先生に質問がありますか？お気軽に
              <a href="/contact" className="en-question-link">
                こちら
              </a>
              からお尋ねください！
            </div>
          </div>
        </div>
      </div>
      <FooterB />
      <VideoView />
    </div>
  );
};

export default Videos;
